<template>
    <div>
        <div v-if="product && displayProduct" class="z-50 top-0 left-0 w-full h-full fixed overflow-y-scroll">
            <product-page @displayProductPage="displayProductPage" :product="product" />
        </div>
      <div class="flex flex-wrap" v-if="products.length">
            <div 
                v-for="(product, index) in products.slice(0,24)" 
                :key="product.slug"
                @click="productDetails(product)"
                :style="{backgroundColor:getColor(index)}"
                class="product-item flex justify-center flex-col py-14 md:py-0 w-full sm:w-6/12 md:w-4/12 xl:w-3/12 px-8"
                >
                <!--router-link :product="product" class="detail-link" :to="{
                    name: 'AppDetails', 
                    params: {slug: product.slug, product:product.id}
                    }"
                    -->
                    <v-lazy-image v-bind:src="product.img_name" class="mx-auto" />
                    <div class="product-reference">{{ product.reference }}</div>
                <!--/router-link-->
            </div>
     </div>  
        <div v-else class="no-products-found py-24 flex flex-row justify-center text-white text-xl montserrat"> Pas de produit disponible </div>
    </div>
</template>
<script>

    import VLazyImage from "v-lazy-image"
    import ProductPage from "@/views/productPage.vue";
    import store from '@/store/index'

    export default {
        components: {
            VLazyImage,
            ProductPage,
        },
        data() {
            return {
                displayProduct:false,
                product: null,
                products: [],
                temp_color : [],
                colors:[
                    '#5F4433', 
                    '#E16600', 
                    '#F39300', 
                    '#fece00', 
                    '#FFCE00', 
                    '#F39300', 
                    '#5F4433', 
                    '#B29149', 
                    '#E16600',
                    '#B29149',
                    '#FFCE00',
                    '#F39300'
                ]
            }
        },
        methods: {
            async productDetails(product) {
                await store.dispatch('showProduct', true)
                await store.dispatch('getProductBySlug', product.slug)
                    .then(response => {
                        this.product = response.data
                        console.log("product here xx")
                        console.log(this.product)
                        this.displayProduct = store.getters.displayProduct
                        console.log(response.data)
                        return response
                    })

            },
            displayProductPage(value) {
                this.displayProduct = value
            },
            getRandomColor(){
                return this.colors[Math.floor(Math.random()*this.colors.length)]
            },
            getColor(index){
                if(index < this.colorsLength){
                    return this.colors[index]
                }
                return this.colors[index - this.colorsLength]
            },
            buildFullCategorySlug(){
                const category = this.$route.params.category
                const sub_category = this.$route.params.sub_category
                return `${category}_${sub_category}`
            },
            async fetchProducts(categoryFullSlug){
                await store.dispatch('fetchProductsCategories', {slug: categoryFullSlug})
                this.products = store.state.products
            },
            async fetchProdutsFromSearch(search){
              await store.dispatch('searchProducts', search.term)
              this.products = store.getters.getProducts
            }
            
        },
        created() {

            /**
             * @TODO Refactoring repeated lines as in watch.
             */
            console.log("route params")
            console.log(this.$route.params)
            if(this.$route.params && this.$route.params.term) {
                this.fetchProdutsFromSearch(this.$route.params)
            } else {
                const category          = this.$route.params.category
                const sub_category      = this.$route.params.sub_category
                const categoryFullSlug  =  `${category}_${sub_category}`
                console.log(this.$route.params)
                this.fetchProducts(categoryFullSlug)
            }

        },
        computed: {
            colorsLength(){
                return this.colors.length
            }
            
        },
        watch: { 
        '$route.params': {
            handler: function(r) {
                console.log('route params')
                console.log(r)

                if(r.term){
                    console.log('fetch search products')
                    this.fetchProdutsFromSearch(r)
                } else {
                    const category = r.category
                    const sub_category = r.sub_category
                    const categoryRoute = `${category}_${sub_category}`
                    this.fetchProducts(categoryRoute)
                }
                
            },
            deep: true,
            immediate: true
        }
    }
    }
</script>
<style scoped>
    
    .product-item {
        cursor: pointer;
    }
     .v-lazy-image {
        opacity: 0;
        transition: opacity 2s;
    }
    .v-lazy-image-loaded {
        opacity: 1;
    }
    .product-item img {
        width: 80%;
        max-width: 237px;
    }
    
    @media(min-width: 980px){
        .product-item {
            height: 436px;
        }
    }
    
</style>